(function(){
  function enhance(root){
    if(!root || root.dataset.lsdEnhanced==='true') return;

    if(document.body.classList.contains('page-dive-medical')){
      root.querySelectorAll('img').forEach(function(image){ image.loading='eager'; });
    }

    var content=root.querySelector(':scope > .lsd-page-content');
    if(!content){ root.dataset.lsdEnhanced='true'; return; }

    if(content.classList.contains('lsd-course-story--start-diving')){
      content.querySelectorAll('.lsd-course-route-list').forEach(function(group){
        var heading=group.querySelector(':scope > h4, :scope > h5');
        var list=group.querySelector(':scope > ul');
        if(!heading || !list || group.querySelector(':scope > .lsd-course-route-disclosure')) return;
        var details=document.createElement('details');
        details.className='lsd-course-route-disclosure';
        details.open=false;
        var summary=document.createElement('summary');
        summary.textContent=heading.textContent;
        details.appendChild(summary);
        details.appendChild(list);
        heading.remove();
        group.appendChild(details);
      });
    }

    var firstHeading=content.querySelector(':scope > h2:first-child');
    if(firstHeading){
      firstHeading.classList.add('lsd-content-intro__title');
      var introCopy=firstHeading.nextElementSibling;
      if(introCopy && introCopy.tagName==='P') introCopy.classList.add('lsd-content-intro__copy');
    }

    var headings=Array.from(content.querySelectorAll(':scope > h3'));
    headings.forEach(function(heading){
      if(heading.closest('.lsd-content-card')) return;
      var card=document.createElement('section');
      card.className='lsd-content-card';
      heading.parentNode.insertBefore(card,heading);
      var node=heading;
      while(node && !(node!==heading && (node.tagName==='H2' || node.tagName==='H3'))){
        var next=node.nextElementSibling;
        card.appendChild(node);
        node=next;
      }
    });

    var children=Array.from(content.children);
    var run=[];
    function flush(){
      if(run.length<2){ run=[]; return; }
      var grid=document.createElement('div');
      grid.className='lsd-content-card-grid';
      run[0].parentNode.insertBefore(grid,run[0]);
      run.forEach(function(card){ grid.appendChild(card); });
      run=[];
    }
    children.forEach(function(child){
      if(child.classList.contains('lsd-content-card')) run.push(child);
      else flush();
    });
    flush();
    root.dataset.lsdEnhanced='true';
  }

  function wakeProductRecommendations(){
    if(!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('product-recommendations').then(function(){
      document.querySelectorAll('product-recommendations[data-recommendations-performed="false"]').forEach(function(element){
        element.setAttribute('data-lsd-autoload', 'true');
      });
    });
  }

  function initCartFeedback(){
    document.querySelectorAll('.add-to-cart-text--added').forEach(function(label){
      if(label.textContent.indexOf('Translation missing:')!==-1) label.textContent='Added to cart';
    });

    if(document.querySelector('[data-lsd-cart-feedback]')) return;
    var feedback=document.createElement('div');
    feedback.className='lsd-cart-feedback';
    feedback.setAttribute('data-lsd-cart-feedback','');
    feedback.setAttribute('role','status');
    feedback.setAttribute('aria-live','polite');
    feedback.hidden=true;
    document.body.appendChild(feedback);

    function updateCount(total){
      document.querySelectorAll('[data-lsd-cart-count]').forEach(function(count){
        count.textContent=String(total);
        count.hidden=total<1;
      });
      document.querySelectorAll('.lsd-header-cart').forEach(function(link){
        link.setAttribute('aria-label','View cart, '+total+(total===1?' item':' items'));
      });
    }

    document.addEventListener('shopify:cart:lines-update',function(event){
      if(event.action!=='add' || event.context!=='product' || !event.promise) return;
      feedback.hidden=false;
      feedback.dataset.state='pending';
      feedback.innerHTML='<span>Adding to cart…</span>';
      event.promise.then(function(result){
        if(result && result.detail && result.detail.didError) throw new Error('Cart update failed');
        var total=result && result.cart ? Number(result.cart.totalQuantity)||0 : 0;
        updateCount(total);
        feedback.dataset.state='success';
        feedback.innerHTML='<strong>Added to cart</strong><a href="/cart">View cart</a>';
      }).catch(function(){
        feedback.dataset.state='error';
        feedback.innerHTML='<strong>Could not add that item.</strong><span>Please try again.</span>';
      });
    });
  }

  function init(){
    document.querySelectorAll('[data-lsd-page-content]').forEach(enhance);
    wakeProductRecommendations();
    initCartFeedback();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
}());
